export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-5 whitespace-nowrap">
              高清免费追剧
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              红桃影院 - 电视剧全集免费在线观看平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-4">
              最新热播 · 同步更新 · 海量资源
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl lg:max-w-none mx-auto lg:mx-0">
              红桃影视为追剧爱好者打造一站式免费观剧平台，汇聚国产剧全集、韩剧在线看等海量高清资源。
              每日同步更新最新电视剧与热播剧集，无需注册即可畅享流畅播放体验。
              无论你偏爱古装传奇、悬疑烧脑还是甜宠言情，红桃影院都能满足你的追剧需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">50+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新集数</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">2000+</div>
                <div className="text-xs text-foreground-500 mt-1">剧集资源覆盖</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">800万+</div>
                <div className="text-xs text-foreground-500 mt-1">追剧用户信赖</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追剧
              </a>
              <a
                href="#ranking"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 rounded-full border-2 border-primary-200 text-primary-700 font-medium text-sm hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看榜单
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-[280px] md:w-[340px] lg:w-[380px]">
            <div className="relative rounded-2xl overflow-hidden aspect-[3/4] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20cinematic%20visual%20with%20warm%20coral%20red%20and%20gold%20tones%2C%20elegant%20film%20reel%20art%20deco%20composition%2C%20streaming%20entertainment%20platform%20aesthetic%2C%20soft%20gradient%20lighting%20on%20minimalist%20background%2C%20modern%20cinematic%20design%20with%20dramatic%20warm%20atmosphere%2C%20premium%20quality%2C%20no%20text%20no%20letters%2C%20abstract%20flowing%20cinematic%20ribbons&width=900&height=1200&seq=hero-drama-main-2026&orientation=portrait"
                alt="红桃影院 - 电视剧在线观看平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}